// The Snack Menu: dishes from the "foods i want to eat" bookmarks.
export const DISHES = [
  'Bagel with cream cheese',
  'Buttered toast',
  'Pancakes and butter',
  'Chocolate chip waffles and whipped cream',
  'Biscuits and gravy',
  'Founding Farmers Sunday morning brunch',
  'Edamame with flaky salt',
  'Cheese flight',
  'Boursin garlic and fine herbs',
  'Bacon with truffle salt',
  'Lime chips and chipotle salsa',
  'Loaded nachos',
  'Quesadilla',
  'Pretzel and cheddar Goldfish',
  'Jerky, sausage and pretzels',
  'Sourdough bread dipped in oil and vinegar',
  'Homemade popcorn and candy',
  'An air-fried, well-seasoned steak',
  'Pasta with butter and parmesan',
  'Pretzel-crust pizza',
  'Ramen hot pot with white rice',
  'Buttered grilled cheese with garlic and pretzels, and tomato soup',
  'German sausage',
  'Peanut butter and jelly sandwich',
  'Huge amounts of white rice with salt',
  'Slim Chickens in Bowie',
  "Zaxby's",
  'Coco cake',
  'Pop-Tart',
  'Cookie ice cream sandwich',
  'Neapolitan bar',
  "Indoor s'mores",
  "Reese's peanut butter cups",
  'Oreos',
  'Christmas cookies',
  'Frosted sugar cookies',
  'Limeade',
  'Boozy slushy',
  'Boozy milkshake',
  'Hard cider and Fireball',
  'Sourdough starter to baked bread, end to end'
];
